import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DbService } from 'src/app/services/db.service';
import { NavigationExtras, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-play-select',
  templateUrl: './play-select.component.html',
  styleUrls: ['./play-select.component.css']
})
export class PlaySelectComponent implements OnInit {

  userId;
  teachercode;

  constructor(
    private router: Router,
    private db: DbService,
    private auth: AuthService
  ) {
    // this.userId = this.authService.userDetails().uid;
    this.userId = localStorage.getItem('userId');

    this.db.doc$(`student/${this.userId}`).subscribe((data) => {
      this.teachercode = data.teacherCode;
    })
  }

  ngOnInit(): void {
  }


  personalGame(): any {
    this.db.updateAt(`student/${this.userId}`, {
      gameType: 'personalPlay'
    });
    this.router.navigate(['/play-personal'], {
      queryParams: {
        gameType: 'personal',
      }
    });
  }

  groupGame() {
    console.log('그룹플레이~!')
    this.db.collection$('teacher', ref => ref.where('teacherCode', '==', this.teachercode)).pipe(take(1)).subscribe((test) => {
      firebase.default.firestore().runTransaction(transaction => {
        return transaction.get(firebase.default.firestore().collection('teacher').doc(test[0].teacherId)).then(eventDoc => {
          return transaction.update(firebase.default.firestore().collection('teacher').doc(test[0].teacherId), {
            groupStudent: firebase.default.firestore.FieldValue.arrayUnion(this.userId)
          })
        }, err => {
          console.log('Error', err);
        })
      })
    })
    this.db.updateAt(`student/${this.userId}`, {
      gameType: 'groupPlay',
      groupPlaySwitch: true,
    });
    this.router.navigate(['/play-personal'], {
      queryParams: {
        gameType: 'group',
      }
    });
    // this.db.collection$('teacher', ref => ref.where('teacherCode', '==', this.teachercode)).pipe(take(1)).subscribe((test) => {
    //   this.db.updateAt(`teacher/${test[0].teacherId}`, {
    //     groupStudent: firebase.default.firestore.FieldValue.arrayUnion(this.userId)
    //   })
    // })
  }

}
